import Vue from 'vue';
import VueRouter from 'vue-router';
// import Layout from '@/views/layouts/main.vue';
// import Profile from '@/views/Profile.vue';
// import ProfilePerformance from '@/components/profile/ProfilePerformance.vue';
// import ProfileMention from '@/components/profile/ProfileMention.vue';
// import ProfileBravo from '@/components/profile/ProfileBravo.vue';
// import ProfileAbout from '@/components/profile/ProfileAbout.vue';
import { i18n } from '@/plugins/vue-i18n';
import qs from 'qs';

Vue.use(VueRouter);

const Notice = () => import('@/components/Notice.vue');
const Header = () => import('@/components/Header.vue');
const Footer = () => import('@/components/Footer.vue');
const Tabbar = () => import('@/components/Tabbar.vue');
const InstrumentsAll = () => import('@/components/instruments/InstrumentsAll.vue');
const InstrumentsKeyboard = () => import('@/components/instruments/InstrumentsKeyboard.vue');
const InstrumentsString = () => import('@/components/instruments/InstrumentsString.vue');
const InstrumentsWind = () => import('@/components/instruments/InstrumentsWind.vue');
const InstrumentsPercussion = () => import('@/components/instruments/InstrumentsPercussion.vue');

const Error = () => import('@/views/404.vue');
const Home = () => import('@/views/Home.vue');
const Explore = () => import('@/views/Explore.vue');
const Genre = () => import('@/views/Genre.vue');
const GenreView = () => import('@/views/Genreview.vue');
const Instruments = () => import('@/views/Instruments.vue');
const InstrumentsView = () => import('@/views/Instrumentsview.vue');
const Tags = () => import('@/views/Tags.vue');
const TagView = () => import('@/views/Tagview.vue');
const Topics = () => import('@/views/Topics.vue');
const TopicsView = () => import('@/views/Topicsview.vue');
const Search = () => import('@/views/Search.vue');
const VideoPage = () => import('@/views/VideoPage.vue');
const SignIn = () => import('@/views/Signin.vue');
const User = () => import('@/views/User.vue');
const Submit = () => import('@/views/Submit.vue');
const About = () => import('@/views/About.vue');
const Terms = () => import('@/views/Terms.vue');
const Privacy = () => import('@/views/Privacy.vue');
const JoinBeta = () => import('@/views/Joinbeta.vue');

const routes = [
  {
    path: '*',
    name: '404',
    components: {
      default: Error,
      nav: Header,
      notice: Notice,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.pagenotfound'),
    },
  },
  {
    path: '/',
    name: 'Home',
    components: {
      default: Home,
      nav: Header,
      notice: Notice,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.home'),
    },
  },
  {
    path: '/signin',
    name: 'Signin',
    components: {
      default: SignIn,
      notice: Notice,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.signin'),
    },
  },
  {
    path: '/user/:id',
    name: 'User',
    components: {
      default: User,
      nav: Header,
      notice: Notice,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.userlikes'),
    },
  },
  {
    path: '/submit',
    name: 'Submit',
    components: {
      default: Submit,
      nav: Header,
      notice: Notice,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.submit'),
    },
  },
  {
    path: '/about',
    name: 'About',
    components: {
      default: About,
      nav: Header,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.about'),
    },
  },
  {
    path: '/beta',
    name: 'Joinbeta',
    components: {
      default: JoinBeta,
      notice: Notice,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.beta'),
    },
  },
  {
    path: '/terms',
    name: 'Terms',
    components: {
      default: Terms,
      nav: Header,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.terms'),
    },
  },
  {
    path: '/privacy',
    name: 'Privacy',
    components: {
      default: Privacy,
      nav: Header,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.privacy'),
    },
  },
  // {
  //   path: '/profile',
  //   name: 'Profile',
  //   components: {
  //     default: Profile,
  //     nav: Header,
  //     footer: Footer,
  //   },
  //   meta: {
  //     title: i18n.t('title.signin'),
  //   },
  //   children: [
  //     {
  //       name: 'ProfilePerformance',
  //       path: '',
  //       component: ProfilePerformance,
  //       meta: {
  //         title: i18n.t('title.signin'),
  //       },
  //     },
  //     {
  //       name: 'ProfileMention',
  //       path: 'mention',
  //       component: ProfileMention,
  //       meta: {
  //         title: i18n.t('title.signin'),
  //       },
  //     },
  //     {
  //       name: 'ProfileBravo',
  //       path: 'bravo',
  //       component: ProfileBravo,
  //       meta: {
  //         title: i18n.t('title.signin'),
  //       },
  //     },
  //     {
  //       name: 'ProfileAbout',
  //       path: 'about',
  //       component: ProfileAbout,
  //       meta: {
  //         title: i18n.t('title.signin'),
  //       },
  //     },
  //   ],
  // },
  {
    path: '/explore',
    name: 'Explore',
    components: {
      default: Explore,
      nav: Header,
      notice: Notice,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.explore'),
    },
  },
  {
    path: '/genre',
    name: 'Genre',
    components: {
      default: Genre,
      nav: Header,
      notice: Notice,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.genre'),
    },
  },
  {
    path: '/genre/:slug',
    name: 'GenreView',
    components: {
      default: GenreView,
      nav: Header,
      notice: Notice,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.genre'),
    },
  },
  // {
  //   path: '/instruments',
  //   name: 'Instruments',
  //   components: {
  //     default: Instruments,
  //     nav: Header,
  //     footer: Footer,
  //   },
  //   meta: {
  //     title: i18n.t('title.instruments'),
  //   },
  // },
  {
    path: '/instruments',
    components: {
      default: Instruments,
      nav: Header,
      notice: Notice,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.instruments'),
    },
    children: [
      {
        name: 'InstrumentsAll',
        path: '',
        component: InstrumentsAll,
        meta: {
          title: i18n.t('title.instruments'),
        },
      },
      {
        name: 'InstrumentsKeyboard',
        path: 'keyboard',
        component: InstrumentsKeyboard,
        meta: {
          title: i18n.t('title.keyboard'),
        },
      },
      {
        name: 'InstrumentsString',
        path: 'string',
        component: InstrumentsString,
        meta: {
          title: i18n.t('title.string'),
        },
      },
      {
        name: 'InstrumentsWind',
        path: 'wind',
        component: InstrumentsWind,
        meta: {
          title: i18n.t('title.wind'),
        },
      },
      {
        name: 'InstrumentsPercussion',
        path: 'percussion',
        component: InstrumentsPercussion,
        meta: {
          title: i18n.t('title.percussion'),
        },
      },
    ],
  },
  {
    path: '/instruments/:slug',
    name: 'InstrumentsView',
    components: {
      default: InstrumentsView,
      nav: Header,
      notice: Notice,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.instruments'),
    },
  },
  {
    path: '/tags',
    name: 'Tags',
    components: {
      default: Tags,
      nav: Header,
      notice: Notice,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.tags'),
    },
  },
  {
    path: '/tags/:slug',
    name: 'TagView',
    components: {
      default: TagView,
      nav: Header,
      notice: Notice,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.tags'),
    },
  },
  {
    path: '/topics/',
    name: 'Topics',
    components: {
      default: Topics,
      nav: Header,
      notice: Notice,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.topics'),
    },
  },
  {
    path: '/topics/:id',
    name: 'TopicsView',
    components: {
      default: TopicsView,
      nav: Header,
      notice: Notice,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.topics'),
    },
  },
  {
    path: '/search',
    name: 'Search',
    components: {
      default: Search,
      nav: Header,
      notice: Notice,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.search'),
    },
  },
  {
    path: '/video/:id',
    name: 'VideoPage',
    components: {
      default: VideoPage,
      nav: Header,
      notice: Notice,
      footer: Footer,
      tabbar: Tabbar,
    },
    meta: {
      title: i18n.t('title.videoPage'),
    },
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },

  mode: 'history',

  // set custom query resolver
  parseQuery(query) {
    return qs.parse(query);
  },

  stringifyQuery(query) {
    const result = qs.stringify(query);
    return result ? `?${result}` : '';
  },
});

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title;
  next();
});

export default router;
